function ascii(str) {
  const out = new Uint8Array(str.length);
  for (let i = 0; i < str.length; i += 1) out[i] = str.charCodeAt(i) & 0xff;
  return out;
}

function concat(parts) {
  const total = parts.reduce((n, p) => n + p.length, 0);
  const out = new Uint8Array(total);
  let o = 0;
  parts.forEach((p) => {
    out.set(p, o);
    o += p.length;
  });
  return out;
}

/** One-page PDF wrapping a JPEG (no extra dependencies). */
export function jpegToPdfBytes(jpegBytes, width, height) {
  const w = Math.max(1, Math.round(width));
  const h = Math.max(1, Math.round(height));
  const img = jpegBytes instanceof Uint8Array ? jpegBytes : new Uint8Array(jpegBytes);

  const objects = [];
  const add = (body, stream) => {
    objects.push({ body, stream: stream || null });
  };

  add('<< /Type /Catalog /Pages 2 0 R >>');
  add('<< /Type /Pages /Kids [3 0 R] /Count 1 >>');
  add(
    `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${w} ${h}] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R >>`
  );
  add(
    `<< /Type /XObject /Subtype /Image /Width ${w} /Height ${h} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${img.length} >>`,
    img
  );
  const content = `q ${w} 0 0 ${h} 0 0 cm /Im0 Do Q\n`;
  const contentBytes = ascii(content);
  add(`<< /Length ${contentBytes.length} >>`, contentBytes);

  const chunks = [ascii('%PDF-1.4\n')];
  const offsets = [0];
  let pos = chunks[0].length;
  objects.forEach((obj, i) => {
    offsets.push(pos);
    const n = i + 1;
    const head = ascii(`${n} 0 obj\n${obj.body}`);
    chunks.push(head);
    pos += head.length;
    if (obj.stream) {
      const mid = ascii('\nstream\n');
      const tail = ascii('\nendstream\nendobj\n');
      chunks.push(mid, obj.stream, tail);
      pos += mid.length + obj.stream.length + tail.length;
    } else {
      const tail = ascii('\nendobj\n');
      chunks.push(tail);
      pos += tail.length;
    }
  });

  const xrefPos = pos;
  let xref = `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`;
  offsets.slice(1).forEach((off) => {
    xref += `${String(off).padStart(10, '0')} 00000 n \n`;
  });
  xref += `trailer << /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xrefPos}\n%%EOF\n`;
  chunks.push(ascii(xref));
  return concat(chunks);
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function canvasToJpegBytes(canvas, quality = 0.92) {
  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('Could not encode JPEG'))),
      'image/jpeg',
      quality
    );
  });
  return new Uint8Array(await blob.arrayBuffer());
}
